import { CountryUtils } from '@xarvio/frontend-core-platform/lib/country/CountryUtils';
import { isFeatureEnabledSafe } from '../../featureFlags/isFeatureEnabled';

export const XARVIO_TENANT_UUID = 'fe7e14f0-1315-4bfd-b980-3dfd1082f66f';
export const BARILLA_TENANT_UUID = '9e0bd29a-2c0b-4de6-8636-e2de0fa3968e';
export const PERONI_TENANT_UUID = '20e9c9dc-e0e9-40ac-88be-4287e715c4d2';
export const GRAPES_TENANT_UUID = 'ff9fbb66-4c49-4d62-af8f-a5c27f904e24';

export const GRAPES_SUPPORTED_COUNTRIES = [
  CountryUtils.COUNTRY.ITALY,
  CountryUtils.COUNTRY.FRANCE,
  CountryUtils.COUNTRY.SPAIN,
  CountryUtils.COUNTRY.TURKEY,
];

export const GRAPES_SUPPORTED_LOCALES = [
  `${CountryUtils.LANGUAGE.FRENCH}_${CountryUtils.COUNTRY.FRANCE}`,
  `${CountryUtils.LANGUAGE.ITALIAN}_${CountryUtils.COUNTRY.ITALY}`,
  `${CountryUtils.LANGUAGE.SPANISH}_${CountryUtils.COUNTRY.SPAIN}`,
  `${CountryUtils.LANGUAGE.TURKISH}_${CountryUtils.COUNTRY.TURKEY}`,
];

export const isBarillaDomain = (): boolean => {
  const { VITE_FM_BARILLA_ORIGIN } = import.meta.env;

  return (
    isFeatureEnabledSafe('FORCE_BARILLA_DOMAIN') ||
    (!!VITE_FM_BARILLA_ORIGIN &&
      window.location.origin === VITE_FM_BARILLA_ORIGIN)
  );
};

export const isPeroniDomain = (): boolean => {
  const { VITE_FM_PERONI_ORIGIN } = import.meta.env;

  return (
    isFeatureEnabledSafe('FORCE_PERONI_DOMAIN') ||
    (!!VITE_FM_PERONI_ORIGIN &&
      window.location.origin === VITE_FM_PERONI_ORIGIN)
  );
};

export const isGrapesDomain = (): boolean => {
  const { VITE_FM_GRAPES_ORIGIN } = import.meta.env;

  return (
    isFeatureEnabledSafe('FORCE_GRAPES_DOMAIN') ||
    (!!VITE_FM_GRAPES_ORIGIN &&
      window.location.origin === VITE_FM_GRAPES_ORIGIN)
  );
};
